// extracted by mini-css-extract-plugin
export default {"root":"Modal_root__EeBKj","container":"Modal_container__EY5Qx"};